// components/ImageDisplay.jsx
import { Box, Typography, CircularProgress } from '@mui/material';
import { useState } from 'react';
import { normalizeImageUrl } from '../utils/constants';

const ImageDisplay = ({ imageUrl, alt, maxWidth = 200, maxHeight = 150, onClick, ...props }) => {
  const [imageError, setImageError] = useState(false);
  const [imageLoaded, setImageLoaded] = useState(false);
  
  const normalizedUrl = normalizeImageUrl(imageUrl);
  
  if (imageError || !normalizedUrl) {
    return (
      <Box
        sx={{
          width: maxWidth,
          height: maxHeight,
          backgroundColor: 'rgba(0,0,0,0.1)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          borderRadius: 1,
          border: '1px dashed rgba(0,0,0,0.3)',
          flexDirection: 'column',
          ...props.sx
        }}
      >
        <Typography variant="caption" color="text.secondary" textAlign="center">
          圖片載入失敗
        </Typography>
        {/* <Typography variant="caption" color="text.secondary" sx={{ fontSize: '0.7rem', mt: 0.5 }}>
          URL: {normalizedUrl}
        </Typography> */}
      </Box>
    );
  }

  return (
    <Box sx={{ position: 'relative', display: 'inline-block' }}>
      {!imageLoaded && !imageError && (
        <Box
          sx={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: maxWidth,
            height: maxHeight,
            backgroundColor: 'rgba(0,0,0,0.1)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            borderRadius: 1,
            zIndex: 1,
            flexDirection: 'column'
          }}
        >
          <CircularProgress size={20} />
          <Typography variant="caption" sx={{ mt: 1, fontSize: '0.7rem' }}>
            載入中...
          </Typography>
        </Box>
      )}
      <Box
        component="img"
        src={normalizedUrl}
        alt={alt}
        sx={{
          maxWidth: maxWidth,
          maxHeight: maxHeight,
          borderRadius: 1,
          cursor: onClick ? 'pointer' : 'default',
          border: '2px solid rgba(255,255,255,0.2)',
          objectFit: 'cover',
          display: 'block',
          opacity: imageLoaded ? 1 : 0,
          transition: 'opacity 0.3s ease-in-out',
          ...props.sx
        }}
        onClick={onClick ? () => onClick(normalizedUrl) : undefined}
        onLoad={() => {
          // console.log('圖片載入成功:', normalizedUrl);
          setImageLoaded(true);
          setImageError(false);
        }}
        onError={(e) => {
          console.error('圖片載入失敗:', normalizedUrl);
          setImageError(true);
          setImageLoaded(false);
        }}
      />
    </Box>
  );
};

export default ImageDisplay;